import { 
	createSlice,
	createAsyncThunk,
	createEntityAdapter
} from '@reduxjs/toolkit'
import {envAwarePost} from '../../util/util'

export const getProgressData = createAsyncThunk(
	'getProgressData',
	async () => envAwarePost('progressAddEditDeleteListMobWeb.php',{
		operation:'list',
		send_response:1
	})
)

const progressAdapter = createEntityAdapter({
	selectId:entity=>entity.assessmentID
})

const progressSlice = createSlice({
	name: 'progress',
	initialState:progressAdapter.getInitialState({
		status:'idle'
	}),
	reducers: {},
	extraReducers:{
		[getProgressData.pending] : (state)=>{
			state.status = 'loading'
		},
		[getProgressData.fulfilled] : (state,action)=>{
			const {success,data} = action.payload
			state.status = 'idle'
			if(success == 1) progressAdapter.upsertMany(state,data)
		},
		[getProgressData.rejected] : (state)=>{
			state.status = 'idle'
		}
	}
})

// Export the customized selectors for this adapter using `getSelectors`
export const {
	selectAll: selectAllProgress,
	selectById: selectProgressById,
	selectIds: selectProgressIds
} = progressAdapter.getSelectors(state => state.progress)


export default progressSlice.reducer